// store/slices/authSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DashboardState {
  id: string;
  diagramId: string;
  currentStep: string;
  opportunity: any;
}

const initialState: DashboardState = {
  id: '',
  diagramId: '',
  currentStep: 'dashboard',
  opportunity: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    updateDashboardData: (state, action: PayloadAction<Partial<DashboardState>>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { updateDashboardData } = dashboardSlice.actions;
export default dashboardSlice.reducer;
